import { TranslatePipe } from '@myre/ui-primitive-core';
import {
  LayoutColumnComponent,
  LayoutComponent,
  LayoutRowContainerComponent,
} from '@myre/ui-primitive-layouts';
import {
  NavbarComponent,
  NavbarLogoComponent,
} from '@myre/ui-primitive-navbar';

import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { InAppNavbarComponent } from '../in-app-navbar/in-app-navbar.component';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  imports: [
    LayoutColumnComponent,
    LayoutComponent,
    LayoutRowContainerComponent,
    NavbarComponent,
    NavbarLogoComponent,
    NgClass,
    TranslatePipe,
  ],
})
export class ErrorComponent extends InAppNavbarComponent {
  public errorCode: number;
  public background: string;

  constructor() {
    super();

    this._title.setTitle('MYRE');
  }

  public ngOnInit(): void {
    this._activatedRoute.data.subscribe((data: { errorCode: number }) => {
      this.errorCode = data.errorCode;
      this.background = `url(/assets/images/backgrounds/${data.errorCode}.gif)`;
    });
  }
}
